import { Dialog, Notify, Quasar } from 'quasar';
import { createApp } from 'vue';
import App from './App.vue';

// Import icon libraries
import '@quasar/extras/material-icons/material-icons.css';

// Import Quasar css
import VueGoogleMaps from '@fawmi/vue-google-maps';
import { createPinia } from 'pinia';
import 'quasar/src/css/index.sass';
import { createI18nInstance } from './i18n'; // import the createI18nInstance function
import router, { addTenantRoutes } from './router';
import cryptService from './services/crypt.service';

declare global {
  interface Window {
    appCfg: any;
  }
}

const initializeApp = async () => {
  const response = await fetch('/api/v1/public/config');
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const configData = await response.json();
  console.log('Config data:', configData);
  const { sym, key } = configData;


  // set config from the server
  cryptService.setSym(sym);
  cryptService.setCfgKey(key);

  const i18n = await createI18nInstance(); // Initialize i18n asynchronously

  const app = createApp(App)
    .use(createPinia())
    .use(i18n)
    .use(Quasar, {
      plugins: {
        Dialog,
        Notify,
      },
      config: {
        dark: false,
      }
    })
    .use(VueGoogleMaps, {
      load: {
        key: 'AIzaSyAwDViM45tQAlyMP1Lw5gSeo7-4YyYIVm8',
        loading: 'async',
        libraries: 'places', // if you need to use the places library
      },
    })
    .use(router);

  router.isReady().then(async () => {
    await addTenantRoutes();
    const current = router.currentRoute.value;
    // if (current.name === 'not-found') {
    //   // Try to re-resolve the route now that routes are added
    router.replace(current.fullPath);
    // }
    // console.log('Routes added:', router.getRoutes());
    // console.log('Current route:', current);
    app.mount('#app');
  });
};

initializeApp().catch((error) => {
  console.error('Failed to initialize the app:', error);
});
